module.exports = __webpack_public_path__ + "img/sale4.294e9c62.png";